<template>

	 <div>
    <Loader v-if="loading" />
  <div v-else-if="record">
    <div class="breadcrumb-wrap">

      <router-link to="/history" class="breadcrumb">История</router-link>
      <a @click.prevent class="breadcrumb">
         {{record.type === 'income' ? 'Доход' : 'Расход'}}
      </a>
    </div>
    <div class="row">
      <div class="col s12 m6">
        <div class="card" :class="{
          'red': record.type === 'outcome',
          'green': record.type === 'income' 
        }">
          <div class="card-content white-text">
            <p>Описание: {{record.description}}</p>
            <p>Сумма: {{record.amount | currency}}</p>
            <p>Категория: {{record.categoryName}}</p>

            <small>{{record.date | date('datetime')}}</small>
          </div>
        </div>
      </div>
    </div>
  </div>
  <p class="center" v-else>Запись c id={{$route.params.id}} не найдена</p>
</div>


</template>

<script>
  //для того чтобы не перезагружалась страница ссылку надо превратить в роутер линк
  export default {
    name: 'detail',
        metaInfo() {
      return { 
       title: this.$title('Detail_Title')
        }
      
    },
    data: () => ({
      record: null,
      loading: true
    }),
    async mounted() {
      //для того чтобы взять айди обращаемся к адресной строке

      const id = this.$route.params.id
      const record = await this.$store.dispatch('fetchRecordById', id)
      const category = await this.$store.dispatch('fetchCategoryById', record.categoryId)

      // debugger
      this.record={
        ...record,
        categoryName: category.title

      }

      // this.record = null проверка когда запись не найдена


      this.loading = false
    }
  }
</script> 